<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]" >
      <el-button style="padding:0 4px;color:#333" @click="logout()" type="text" v-if="to == '/logout'">
        <!-- <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" /> -->
        <span style="margin-left:2px" v-html="icon"></span>
          <slot />
      </el-button>
      <template v-else>
        <router-link
        tabindex="-1"
        v-if="to"
        exact
        :class="[{'router-link-active': activeLink}]"
        :to="to"
        :target="target" >
          <!-- <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" /> -->
        <span v-html="icon"></span>

          <slot />
      </router-link>

      <a v-else :target="target" :href="href" tabindex="-1">
        <span v-html="icon"></span>
        <!-- <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" /> -->
        <slot />
      </a>
      </template>
  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
  },
  computed: {
    activeLink() {
      return ((this.to == this.$route.path) || (this.$route.meta.parent == this.slug) && this.to) ? true : false
    }
  },
  methods:{
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    logout() {
      this.$confirm("هل تريد تسجيل الخروج ؟", "تحذير", {
        confirmButtonText: "موافق",
        cancelButtonText: "رفض",
        type: "warning",
        center: true,
      })
        .then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("menu");
          localStorage.removeItem("permissionNames");
          this.goTo("/login");
          this.$message({
            type: "success",
            message: "تم تسجيل الخروج بنجاح",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'تم إلغاء'
          // });
        });
    },
  }
}

</script>

<style lang="scss">
.v-nav-menu .vs-sidebar--item a{
  padding: 10px 10px !important;
}
.vs-sidebar--item{
  svg{
    width:25px !important;
    height: 25px !important;
    margin:0 5px; 
  }
}
.group-header{
  padding: 10px 7px !important;
  span{
    &:first-of-type{
      svg{
        width:25px !important;
        height: 25px !important;
        margin:0 5px; 
      }
    }
  }
}
.vs-sidebar-item-active{
  svg{
    path{
      fill: #FFF !important
    }
  }
}
.vs-sidebar-group-items{
  .vs-sidebar--item{
    svg{
      width: 16px !important;
      height: 16px !important;
    }
  }
}
</style>